import { DearDocAppointmentTypes, DearDocProvider } from '@/types/api.types';

export const getAvailableAppointmentTypes = (
  providers: DearDocProvider[],
): DearDocAppointmentTypes[] => {
  const allAppointmentTypes = providers.flatMap((provider) => provider.appointment_types);

  const uniqueAppointmentTypesMap = new Map(
    allAppointmentTypes.map((appointmentType) => [appointmentType.id, appointmentType]),
  );

  return Array.from(uniqueAppointmentTypesMap.values());
};

export const getProvidersForAppointmentType = (
  providers: DearDocProvider[],
  appointmentType: string,
): DearDocProvider[] => {
  return providers.filter((provider) =>
    provider.appointment_types.some((type) => type.id === appointmentType),
  );
};
